import { PARTNERS } from "@/lib/data";

export default function Marquee() {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <section
      data-testid="partners-marquee"
      className="relative bg-[#0a0a0b] border-y border-white/10 py-10 md:py-14 overflow-hidden"
    >
      <p className="text-center text-[11px] uppercase tracking-[0.3em] text-white/40 mb-8">
        Trusted by the biggest names in the hobby
      </p>
      <div className="flex overflow-hidden select-none">
        <div className="marquee-track flex whitespace-nowrap items-center">
          {items.map((p, i) => (
            <span
              key={i}
              className="font-display font-extrabold uppercase tracking-tight text-stroke text-5xl md:text-7xl px-8 md:px-12"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
